module.exports = __webpack_public_path__ + "static/media/3.21ed9e90.png";